import React, { createContext, ReactNode, useMemo } from 'react'
import { getUseVodItems } from '@/shared/getContainer/getUseVodItems'
import VodItem from '@/features/VOD/vodClasses/vodItem'
import { useItemFetcher } from '@/features/VOD/hooks/useItemFetch'

interface VodItemsContextType {
    rowItems: VodItem[]
    recommendationItems: VodItem[]
    getItems: (rowId?: string, query?: string) => Promise<VodItem[]>
    setRowItems: (items: VodItem[]) => VodItem[]
    isLoading: boolean
    isError: boolean
    getRecommendationItems: () => void
}

export const VodItemsContext = createContext<VodItemsContextType | undefined>(
    undefined
)
const useVodItems = await getUseVodItems()

export const VodItemsProvider: React.FC<{
    productId: string
    type: string
    children: ReactNode
    serviceName: string
    url?: string
    isCardOrientationPriorityHorizontal?: boolean
}> = ({
    productId,
    children,
    type,
    serviceName,
    url,
    isCardOrientationPriorityHorizontal,
}) => {
    const {
        rowItems,
        recommendationItems,
        getItems,
        setRowItems,
        isLoading,
        isError,
        getRecommendationItems,
    } = useVodItems(
        productId,
        type,
        serviceName,
        url,
        isCardOrientationPriorityHorizontal
    )

    useItemFetcher(productId, setRowItems, getItems)
    const contextValue = useMemo(
        () => ({
            rowItems,
            recommendationItems,
            getItems,
            setRowItems,
            isLoading,
            isError,
            getRecommendationItems,
        }),
        [
            rowItems,
            getItems,
            isLoading,
            isError,
            getRecommendationItems,
            recommendationItems,
            getRecommendationItems,
        ]
    )

    return (
        <VodItemsContext.Provider value={contextValue}>
            {children}
        </VodItemsContext.Provider>
    )
}
